// Brand constants
export const BRAND = {
    name: 'PlacementPilot',
    subtitle: 'by ExcellenC',
    logoUrl: 'https://customer-assets.emergentagent.com/job_22a23844-e153-4f24-8e5d-44cde8667f95/artifacts/0du3vfjj_ExcellenC%20logo%20May%2017%202025.png',
    tagline: 'Ace Your Next Interview — AI-powered mock interviews for Data Analytics, Business Analytics & Data Science learners',
    heroTagline: 'Ace Your Next Interview',
    heroSub: 'AI-powered mock interviews with voice, real-time evaluation, and a full 5-round journey — built for ExcellenC learners.',
};

export const COURSES = [
    {
        key: 'Data Analytics',
        icon: 'TrendingUp',
        color: '#1C3A94',
        modules: ['Excel', 'SQL', 'Tableau', 'Power BI', 'Python'],
        description: 'Master the tools of a modern analyst — from spreadsheets to interactive dashboards.',
    },
    {
        key: 'Business Analytics',
        icon: 'Briefcase',
        color: '#E52C2C',
        modules: ['Excel', 'SQL', 'Power BI', 'JIRA', 'Python'],
        description: 'Blend business acumen with data — requirement gathering, KPIs, and stakeholder communication.',
    },
    {
        key: 'Data Science',
        icon: 'Brain',
        color: '#7C3AED',
        modules: ['Python', 'SQL', 'ML', 'Statistics', 'Deep Learning'],
        description: 'End-to-end machine learning — from data wrangling to production models.',
    },
];

export const ROUNDS = [
    { num: 1, name: 'Technical', desc: 'Course-specific technical questions' },
    { num: 2, name: 'Case Study', desc: 'Real-world business scenarios' },
    { num: 3, name: 'Behavioral / HR', desc: 'STAR-method situational questions' },
    { num: 4, name: 'Final Review', desc: 'Career goals, motivation, culture fit' },
    { num: 5, name: 'Salary Negotiation', desc: 'Practice negotiating your offer' },
];
